import { addOffsetHoursToOtherTimeZone } from './addOffsetHoursToOtherTimeZone';

export const formatDateToChileanTimeZoneString = (date: Date): string => {
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const chileanTimezone = 'America/Santiago';

  // If the client is already in Chilean timezone, return the date as is
  if (clientTimezone === chileanTimezone) {
    return date.toISOString();
  }

  const dateInClientTimezone = addOffsetHoursToOtherTimeZone(date, clientTimezone);

  return dateInClientTimezone.toISOString();
};
